import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDLozenge } from '@facet-wealth/design';
import { COLOR_INFO, COLOR_SUCCESS, COLOR_ERROR } from 'Consts/facetDesignLibrary';
import { NOT_READY_TO_SEND_STATUS, PROPOSED_STATUS, READY_TO_SEND_STATUS } from 'Consts/ScenarioProposal';
import { dataAttrs } from 'Helpers/Testing';

const getColor = (status) => {
  // eslint-disable-next-line default-case
  switch (status) {
    case PROPOSED_STATUS:
      return COLOR_SUCCESS;
    case READY_TO_SEND_STATUS:
      return COLOR_INFO;
    case NOT_READY_TO_SEND_STATUS:
      return COLOR_ERROR;
    default:
      return COLOR_INFO;
  }
};

const StatusChip = () => {
  const { pageContentResource } = usePageContentContext();
  const color = getColor(pageContentResource.attr('status'));

  return (
    <FDLozenge
      color={color}
      label={pageContentResource.selectedOptionPrompt('status')}
      size={'lg'}
      {...dataAttrs('status-chip')}
    />
  );
};

StatusChip.defaultProps = {};

StatusChip.propTypes = {};

export default StatusChip;
